// Borradores del diagnóstico técnico, separados por usuario y orden, con la versión base de la
// orden sobre la que se escribieron (§7).
import { getDb, type DraftRecord } from './db.ts';

export type DraftValues = Pick<DraftRecord, 'model' | 'serial' | 'diagnosis' | 'solution'>;

const key = (userId: string, orderId: string) => `${userId}:${orderId}`;

export async function getDraft(userId: string, orderId: string): Promise<DraftRecord | undefined> {
  const draft = await (await getDb()).get('drafts', key(userId, orderId));
  // Borradores anteriores al campo Modelo: se completan con vacío.
  return draft
    ? { ...draft, model: draft.model ?? '', base: { ...draft.base, model: draft.base.model ?? '' } }
    : undefined;
}

export async function saveDraft(
  userId: string,
  orderId: string,
  baseVersion: number,
  base: DraftValues,
  values: DraftValues,
) {
  await (
    await getDb()
  ).put('drafts', {
    key: key(userId, orderId),
    userId,
    orderId,
    baseVersion,
    base: { model: base.model, serial: base.serial, diagnosis: base.diagnosis, solution: base.solution },
    ...values,
    updatedAt: Date.now(),
  });
}

export async function deleteDraft(userId: string, orderId: string): Promise<void> {
  await (await getDb()).delete('drafts', key(userId, orderId));
}

export async function listDrafts(userId: string): Promise<DraftRecord[]> {
  return (await getDb()).getAllFromIndex('drafts', 'byUser', userId);
}
